// FT-220 CTR-08: подсветка клеток, а не автоматически нарисованные находки.
const validCell = (cell) => Number.isInteger(cell) && cell >= 0 && cell <= 8;
const validProbability = (value) => Number.isFinite(value) && value >= 0 && value <= 1;

// Источник правила клеток — сервер (DamageControl::Warnings::DisplayCells).
// Клиентское правило — защитный запасной путь.
// Возвращает номера клеток; исходный массив не меняет. Повтор клетки не увеличивает сумму.
export function displayCells(topCells) {
  if (!Array.isArray(topCells)) return [];
  const sorted = topCells
    .filter((item) => item && validCell(item.cell) && validProbability(item.probability))
    .slice()
    .sort((a, b) => b.probability - a.probability || a.cell - b.cell);
  const cells = [];
  let sum = 0;
  for (const item of sorted) {
    // Погрешность сложения дробей (например, 0.7 + 0.1) не должна добавлять лишнюю клетку.
    if (cells.length >= 3 || sum >= 0.8 - Number.EPSILON) break;
    if (cells.includes(item.cell)) continue;
    cells.push(item.cell);
    sum += item.probability;
  }
  return cells;
}

export function cellRect(cell) {
  if (!validCell(cell)) return null;
  return { x: (cell % 3) / 3, y: Math.floor(cell / 3) / 3, w: 1 / 3, h: 1 / 3 };
}

// FT-220 CTR-08: только здесь знаем форму поля warning (api DamageControl::Warnings::Payload). Сервер
// отдаёт его лишь для показанного предупреждения, иначе null; клетки показа (display_cells) считает
// DamageControl::Warnings::DisplayCells; клиентское правило — защитный запасной путь, если поля нет.
export function shotWarning(shot) {
  const warning = shot && shot.warning;
  if (!warning || typeof warning !== "object" || Array.isArray(warning) || warning.shown === false) return null;
  const topCells = Array.isArray(warning.top_cells) ? warning.top_cells : [];
  const serverCells = Array.isArray(warning.display_cells) ? warning.display_cells.filter(validCell).slice(0, 3) : [];
  return { ...warning, top_cells: topCells, display_cells: serverCells.length ? serverCells : displayCells(topCells) };
}

export function warningTextKey(warning, side) {
  return warning && warning.stage === "pair" && side === "arrival"
    ? "damage_control.warnings.pair"
    : "damage_control.warnings.single";
}
